import { render, staticRenderFns } from "./TitleWithBadge.vue?vue&type=template&id=0864af5a&"
import script from "./TitleWithBadge.ts?vue&type=script&lang=js&"
export * from "./TitleWithBadge.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports